import { LEGACY_COMPANY_ID_THRESHOLD } from 'src/constants/legacyCompanyThreshold'
import { localStorageKeys } from 'src/constants/localStorageKeys'

/**
 * 現在ログイン中の企業が「既存顧客」かどうかを判定する。
 *
 * 既存顧客（company_id <= LEGACY_COMPANY_ID_THRESHOLD）には、
 * 段階的に廃止予定の機能（表形式ひな形・取込み項目・レイアウト選択）を引き続き表示する。
 *
 * 将来的に全顧客で機能を廃止する際は、この関数とその呼び出し箇所を削除する。
 */
export const isLegacyCompany = (): boolean => {
  const companyIdRaw = localStorage.getItem(localStorageKeys.loginCompanyId)
  if (!companyIdRaw) return false
  const companyId = Number(companyIdRaw)
  if (Number.isNaN(companyId)) return false
  return companyId <= LEGACY_COMPANY_ID_THRESHOLD
}
